import React from "react";

const Navbar = () => {
    return (
        <div className="fixed top-0 left-0 text-center w-full header bg-violet-600 py-4 text-white font-bold text-lg shadow-lg">
            Todo application with react-redux & RTK query
        </div>
    );
};

export default Navbar;
